class CustomMessageCtrl {
    constructor(AgendaOverzicht, CustomMessageApi, DoclrModalService, praktijkContext, notificationService, $rootScope) {
        'ngInject';

        this.CustomMessageApi = CustomMessageApi;
        this.DoclrModalService = DoclrModalService;
        this.praktijkContext = praktijkContext;
        this.notificationService = notificationService;
        this.AgendaOverzicht = AgendaOverzicht
        this.$rootScope = $rootScope;
        this.calendars;

    }

    $onInit() {
        this._loadCustomMessageList();
        this._loadCalendarList();
    }

    onAdd() {
        let newPersonNotification = {
            partyId: this.praktijkContext.id,
            patientId: this.person.id,
            notificationText: undefined,
            gpName: undefined,
            channel: 'SMS'
        };

        this.DoclrModalService.openAddModal(
            '/partials/patientenbeheer/custom-message/custom-message.add.modal.html',
            {
                calendars: this.calendars,
                model:newPersonNotification
            })
            .then(() => this._onApplySendNotification(newPersonNotification), () => {});
    }


    _onApplySendNotification(newPersonBlock){
        this.CustomMessageApi.create(newPersonBlock)
            .then(()=>this._loadCustomMessageList())
            .then(()=>this.$rootScope.$broadcast('$customMessageCreated'))
            .then(()=>this.notificationService.showSuccess(doclrVertaal.instant('person.custom-message.send')))
            .catch(angular.noop);
    }


    _loadCustomMessageList(){
        this.CustomMessageApi
            .findAll(this.person.id)
            .then((notifications) => this.notifications = notifications)
            .catch(angular.noop);
    }

    _loadCalendarList(){
        return this.AgendaOverzicht.get(this.praktijkContext.id)
            .then(c => this.calendars = c)
            .catch(angular.noop);
    }

}

(function () {
    'use strict';

    angular.module('doclr.customMessage')
        .directive('charCount', ['$log', '$timeout', function($log, $timeout){
            return {
                restrict: 'A',
                compile: function compile()
                {
                    return {
                        post: function postLink(scope, iElement, iAttrs)
                        {
                            iElement.bind('keydown', function()
                            {
                                scope.$apply(function()
                                {
                                    scope.numberOfCharacters = iElement.val().length;
                                });
                            });
                            iElement.bind('paste', function()
                            {
                                $timeout(function ()
                                {
                                    scope.$apply(function()
                                    {
                                        scope.numberOfCharacters = iElement.val().length;
                                    });
                                }, 200);
                            });
                        }
                    }
                }
            }
        }])
        .component('customMessage', {
            templateUrl: '/partials/patientenbeheer/custom-message/custom-message.component.html',
            controller: CustomMessageCtrl,
            controllerAs: 'customMessageCtrl',
            bindings: {
                person: '<'
            }
        })
        .component('customMessageList', {
            templateUrl: '/partials/patientenbeheer/custom-message/custom-message-list.component.html',
            controller: CustomMessageCtrl,
            controllerAs: 'customMessageCtrl',
            bindings: {
                person: '<'
            }
        });
})();
